import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-subscribe',
    templateUrl: './subscribe.component.html',
    imports: [MatFormField, MatInput, MatIcon, NgIf, ReactiveFormsModule, RouterLink]
})
export class SubscribeComponent {
    subscriberForm = this.fb.group({
        subscriberEmail: ['', [Validators.email, Validators.minLength(1)]]
      });

    private readonly errorMessage = $localize`Sorry, an error has happened`;
    subscribedToNews: boolean = false;
    constructor(private fb: FormBuilder, private authService: AuthService) { }

    ngOnInit(): void {
    }

    public subscribe() {
        var subscriberEmail = this.subscriberForm.controls['subscriberEmail'].value!
    
        if (this.subscriberForm.valid && subscriberEmail.length > 0) {
          this.authService.subscribe(subscriberEmail).subscribe(_ => {
            this.subscribedToNews = true;
          });
        }
      }
}